import { CallApi } from "app/_helpers/CallApi/CallApi";
import { MEETING_STATUS_VIEW } from "app/_pages/_healthSafetyEnvironment/EHSAuditsMeetings/CONSTANT";
import { RestMethod } from "../../_helpers/ApiConfig/RestMethod";
import { USER_DATA_CONSTANT } from "app/_constants/Redux/userData.constant";
import configureStore from "../../redux/Store";
let { Store } = configureStore();

export async function getAllEventSchedules(filter) {
  let url = "/global-configuration/ehs-module/all-event-schedules?";
  if (filter) url += filter;
  try {
    const eventsData = Store.getState()?.userManagement?.allEventSchedule;
    if (!eventsData?.data?.length || filter) {
      const response = await CallApi(url, "GET");
      const { status, message, data } = response;
      Store.dispatch({
        type: USER_DATA_CONSTANT.ALL_EVENT_SCHEDULE,
        data: Array.isArray(data)
          ? data.map((d, index) => {
              return {
                ...d,
                sid: index + 1,
                scheduleId: d?.scheduleId,
                site: d?.site,
                type: d?.event?.name,
                date: d?.date,
                eventName: d?.event?.name,
                meetingLabel: d?.event?.meetingLabel,
                id: d?.id,
                eventStatus: d?.eventStatus,
                eventStatusView: `${MEETING_STATUS_VIEW[d?.eventStatus]} ${
                  d?.isBack ? "!" : ""
                }`,
                event: d?.event,
                isExecuted: d?.isExecuted,
                progressTotalTask: d?.tasks.length,
                progressCompleteTask: d?.tasks?.filter((task) => task.isCompleted == 1)
                  .length,
                isProgress: d?.isProgress,
                siteName: d?.site?.name,
              };
            })
          : data,
      });
      return {
        status,
        message,
        data: Array.isArray(data)
          ? data.map((d, index) => {
              return {
                ...d,
                sid: index + 1,
                scheduleId: d?.scheduleId,
                site: d?.site,
                type: d?.event?.name,
                date: d?.date,
                eventName: d?.event?.name,
                meetingLabel: d?.event?.meetingLabel,
                id: d?.id,
                eventStatus: d?.eventStatus,
                eventStatusView: `${MEETING_STATUS_VIEW[d?.eventStatus]} ${
                  d?.isBack ? "!" : ""
                }`,
                event: d?.event,
                isExecuted: d?.isExecuted,
                progressTotalTask: d?.tasks.length,
                progressCompleteTask: d?.tasks?.filter((task) => task.isCompleted == 1)
                  .length,
                isProgress: d?.isProgress,
                siteName: d?.site?.name,
              };
            })
          : data,
      };
    } else {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            status: 1,
            message: "Data from store",
            data: eventsData?.data,
          });
        }, 0);
      });
    }
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
export const getAllOHSEHistory = async () => {
  let url = "/global-configuration/ehs-module/login-user-ohse-approval-history";
  const result = await CallApi(url, "GET");

  const { status, message, data = [] } = result;

  return {
    status,
    message,
    data: {
      approver: data?.approver?.map((d, index) => {
        return {
          ...d,
          sid: index + 1,
          siteName: d?.site?.name,
          eventStatusView: `${MEETING_STATUS_VIEW[d?.eventStatus]} ${
            d?.isBack ? "!" : ""
          }`,
          type: d?.event?.name,
          meetingLabel: d?.event?.meetingLabel,
          progressTotalTask: d?.tasks.length,
          progressCompleteTask: d?.tasks?.filter((task) => task.isCompleted == 1).length,
        };
      }),
      reviewer: data?.reviewer?.map((d, index) => {
        return {
          ...d,
          sid: index + 1,
          siteName: d?.site?.name,
          eventStatusView: `${MEETING_STATUS_VIEW[d?.eventStatus]} ${
            d?.isBack ? "!" : ""
          }`,
          type: d?.event?.name,
          meetingLabel: d?.event?.meetingLabel,
          progressTotalTask: d?.tasks.length,
          progressCompleteTask: d?.tasks?.filter((task) => task.isCompleted == 1).length,
        };
      }),
      schedular: data?.schedular?.map((d, index) => {
        return {
          ...d,
          sid: index + 1,
          siteName: d?.site?.name,
          eventStatusView: `${MEETING_STATUS_VIEW[d?.eventStatus]} ${
            d?.isBack ? "!" : ""
          }`,
          type: d?.event?.name,
          meetingLabel: d?.event?.meetingLabel,
          progressTotalTask: d?.tasks.length,
          progressCompleteTask: d?.tasks?.filter((task) => task.isCompleted == 1).length,
        };
      }),
    },
  };
};

export async function myOHSE() {
  let url = "/global-configuration/ehs-module/my-event-schedules";
  const result = await CallApi(url, "GET");

  const { status, message, data } = result;

  return {
    status,
    message,
    data: Array.isArray(data)
      ? data.map((d, index) => {
          return {
            ...d,
            sid: index + 1,
            scheduleId: d?.scheduleId,
            site: d?.site,
            type: d?.event?.name,
            date: d?.date,
            eventName: d?.event?.name,
            id: d?.id,
            eventStatus: d?.eventStatus,
            eventStatusView: `${MEETING_STATUS_VIEW[d?.eventStatus]} ${
              d?.isBack ? "!" : ""
            }`,
            event: d?.event,
            isExecuted: d?.isExecuted,
            progressTotalTask: d?.tasks.length,
            progressCompleteTask: d?.tasks?.filter((task) => task.isCompleted == 1)
              .length,
            isProgress: d?.isProgress,
            siteName: d?.site?.name,
          };
        })
      : data,
  };
}

export async function getMyEventTask(filter) {
  let url = "/global-configuration/ehs-module/my-event-task?";

  if (filter) url += filter;

  try {
    const response = await RestMethod.GET(url);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function getByIdEventTask(id) {
  let url = "/global-configuration/ehs-module/event-task/" + id;

  //if (filter) url += filter;

  try {
    const response = await RestMethod.GET(url);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
export async function getAllEventTask(filter) {
  let url = "/global-configuration/ehs-module/event-task?";

  if (filter) url += filter;

  try {
    const response = await RestMethod.GET(url);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function getAllTaskRevert(filter) {
  let url = "/global-configuration/ehs-module/get-reverted-tasks";

  if (filter) url += filter;

  try {
    const response = await RestMethod.GET(url);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function getEventScheduleById(id) {
  let url = "/global-configuration/ehs-module/get-event-schedule-by-id/" + id;

  try {
    const response = await RestMethod.GET(url);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function createEventSchedule(data) {
  try {
    const response = await RestMethod.POST(
      "/global-configuration/ehs-module/create-event-schedule",
      data
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function updateEventTask(id, data) {
  try {
    const response = await RestMethod.PUT(
      "/global-configuration/ehs-module/update-event-task/" + id,
      data
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
export async function updateEventSchedule(id, data) {
  try {
    const response = await RestMethod.PUT(
      "/global-configuration/ehs-module/update-event-schedule/" + id,
      data
    );
    if (response.status)
      Store.dispatch({
        type: USER_DATA_CONSTANT.ALL_EVENT_SCHEDULE,
        data: [],
      });
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function updateEventScheduleDetails(id, data) {
  try {
    const response = await RestMethod.PUT(
      "/global-configuration/ehs-module/update-event-schedule-details/" + id,
      data
    );
    if (response.status)
      Store.dispatch({
        type: USER_DATA_CONSTANT.ALL_EVENT_SCHEDULE,
        data: [],
      });
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function deleteEventSchedule(id) {
  try {
    const response = await RestMethod.DELETE(
      "/global-configuration/ehs-module/delete-event-schedule/" + id
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function revertedTask(id, data) {
  let url = "/global-configuration/ehs-module/revert-task-owner/" + id;

  try {
    const response = await RestMethod.PUT(url, data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function deleteTask(id, data) {
  try {
    const response = await RestMethod.PUT(
      "/global-configuration/ehs-module/delete-task-owner/" + id,
      data
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function updateRevertTask(id, data) {
  try {
    const response = await RestMethod.PUT(
      "/global-configuration/ehs-module/update-reverted-task-owner/" + id,
      data
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
